import {
  AndroidIcon,
  IOSIcon,
  StudioIcon,
  WebIcon,
} from "pages/internal-dashboard/iconComponents";
import {
  AthleticsIcon,
  BaseballIcon,
  GolfIcon,
  LaunchMonitorIcon,
  ThreeDMotionIcon,
} from "pages/internal-dashboard/icons";

export const platefromTabsArr = [
  {
    icon: StudioIcon,
    label: "Studio",
    key: "desktop",
    inActiveFill: "#1C1C1D",
  },
  {
    icon: WebIcon,
    label: "Web",
    key: "web",
    inActiveFill: "black",
  },
  {
    icon: AndroidIcon,
    label: "Android",
    key: "android",
    inActiveFill: "#A4C639",
  },
  {
    icon: IOSIcon,
    label: "iOS",
    key: "iOS",
    inActiveFill: "black",
  },
];

export const featureTabsArr = [
  {
    icon: ThreeDMotionIcon,
    label: "3D Motion Analysis",
    key: "3d",
  },
  {
    icon: LaunchMonitorIcon,
    label: "Launch Monitor",
    key: "launch",
  },
];
export const sportTabsArr = [
  {
    icon: GolfIcon,
    label: "Golf",
    key: "golf",
  },
  {
    icon: BaseballIcon,
    label: "Baseball",
    key: "baseball",
  },
  {
    icon: AthleticsIcon,
    label: "Athletics",
    key: "athletics",
  },
];
